import React, { useEffect, useRef } from "react";
import { initGame } from "./gameLogic"; // Updated import path

const Game = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    let cleanupGame = () => {}; // Initialize with an empty function

    if (canvas) {
      cleanupGame = initGame(canvas);
    } else {
      console.error("Canvas ref not available on mount");
    }

    // Return the cleanup function provided by initGame
    return () => {
      cleanupGame();
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div style={{ textAlign: "center" }}>
      <canvas
        ref={canvasRef}
        // Set initial dimensions via ref attributes if needed, though initGame handles it
        // width={300} // Example, but managed by initGame
        // height={400} // Example, but managed by initGame
        style={{ border: "1px solid black", cursor: "pointer" }}
      ></canvas>
    </div>
  );
};

export default Game;
